<tiime-card>
  <tiime-card-header>
    <div tiimeCardHeaderTitle class="placeholder"></div>
    <div tiimeCardHeaderActions class="placeholder"></div>
  </tiime-card-header>
  <div tiimeCardContent>
    @for (line of linesArray(); track $index) {
      <div class="tiime-card-content-line placeholder"></div>
    }
  </div>
</tiime-card>
